unit GiftAidDetailsForm;

interface

uses
  System.SysUtils,
  System.Classes,
  JS,
  Web,
  WEBLib.Graphics,
  WEBLib.Controls,
  WEBLib.Forms,
  WEBLib.Dialogs,
  BaseForm,
  WEBLib.ExtCtrls,
  WEBLib.Actions,
  Data.DB,
  WEBLib.DB,
  WEBLib.Toast,
  Vcl.Controls,
  WEBLib.WebCtrls,
  Vcl.StdCtrls,
  WEBLib.StdCtrls,
  WEBLib.DBCtrls,
  WEBLib.Grids,
  XData.Web.JsonDataset,
  XData.Web.Dataset,
  GiftAid.Entities.Claims.Enumerations;

type
  TGiftAidDetails = class(TBaseEditForm)
    GiftAidId: TDBLabel;
    TransactionId: TDBLabel;
    CorrelationId: TDBLabel;
    ClaimRef: TDBLabel;
    ClaimStatus: TDBLabel;
    Comments: TDBLabel;
    SubmissionDate: TDBLabel;
    IRMark: TDBLabel;
    R68Link: TLabel;
    HMRCErrorMessage: THTMLSpan;
    SubmitJobLink: TLabel;
    ClaimStats: TXDataWebDataSet;
    ClaimStatsSource: TDataSource;
    ClaimStatsId: TIntegerField;
    ClaimStatsClaimId: TIntegerField;
    ClaimStatsGiftAid: TFloatField;
    ClaimStatsAmount: TFloatField;
    ClaimStatsClaimType: TStringField;
    ClaimStatsItemCount: TIntegerField;
    ClaimStatsTable: TDBTableControl;
    ClaimStatsClaim_Type: TStringField;
    ClaimStatsTaxYear: TIntegerField;
    IRMarkReceipt: THTMLSpan;
    AmountReceived: TDBLabel;
    AmountReceivedButton: TButton;
    AmountReceivedCurrency: TLabel;
    procedure ClaimStatsAmountGetText(Sender: TField; var Text: string; DisplayText: Boolean);
    procedure ClaimStatsCalcFields(Dataset: TDataSet);
    procedure ClaimStatsGiftAidGetText(Sender: TField; var Text: string; DisplayText: Boolean);
    procedure ClaimStatsItemCountGetText(Sender: TField; var Text: string; DisplayText: Boolean);
    procedure ClaimStatsTaxYearGetText(Sender: TField; var Text: string; DisplayText: Boolean);
    procedure ClaimStatsTableGetCellChildren(Sender: TObject; ACol, ARow: Integer;
        AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure ClaimStatsAfterOpen(DataSet: TDataSet);
    procedure R68LinkClick(Sender: TObject);
    procedure SubmitJobLinkClick(Sender: TObject);
    procedure AmountReceivedButtonClick(Sender: TObject);
  private
    FOpenedClaimId: Integer;
    procedure RefreshClaimStatsTable;
    function OpenedClaimStatus: string;
    function OpenedClaimRef: string;
    [async]
    procedure DownloadR68; async;
    [async]
    procedure GetAmountReceivedFromUser; async;
    procedure SetElementDisplay(const AElementId: string; AVisible: Boolean);
    function IsAdjustmentCommentsDump(const AComments: string): Boolean;
    [async]
    procedure OpenSubmitJob; async;
    procedure UpdateHMRCErrorDisplay(AClaimStatus: TGiftAidClaimStatus);
    procedure AfterSetDataset; override;
    [async]
    procedure ShowClaimItems(const AClaimType: string; ATaxYear: Integer); async;
    [async]
    procedure ShowClaimDonations(AClaimId, ATaxYear: Integer); async;
    [async]
    procedure ShowClaimAdjustments(AClaimId, ATaxYear: Integer;
      const AEntitySetName, ATitle: string); async;
    [async]
    procedure ShowClaimOtherItems(AFormClass: TFormClass; AClaimId,
      ATaxYear: Integer; const AEntitySetName, ATitle: string); async;
  protected
    procedure RecordChanged; override;

  public
    { Public declarations }
  protected procedure LoadDFMValues; override; end;

var
  GiftAidDetails: TGiftAidDetails;

implementation

uses
  System.Rtti,
  XData.Web.Client,
  MainDataModule,
  SMX.Web.Utils,
  SMX.Web.FileSupport,
  GiftAidClaimsList,
  SMX.ReturnTypes,
  ClaimAmountReceivedForm,
  SMX.Web.Layout.Utils,
  ClaimScopedList,
  DonationList,
  ClaimAdjustmentsPopup,
  OtherClaimsGASDSList,
  OtherClaimsList,
  OtherClaimsCommunityBuildingsList,
  OtherClaimsConnectedCharitiesList,
  SharedDataModule,
  Job.DetailForm.Manager,
  JobDetailBaseForm,
  JobDetailForm;

{$R *.dfm}

procedure TGiftAidDetails.AfterSetDataset;
begin
  inherited;
  AmountReceivedButton.Visible := DataSet.FieldByName('ClaimStatus').AsString = 'PaymentReceived';
end;

procedure TGiftAidDetails.AmountReceivedButtonClick(Sender: TObject);
begin
  inherited;
  GetAmountReceivedFromUser;
end;

procedure TGiftAidDetails.RefreshClaimStatsTable;
begin
  ClaimStatsTable.DataSource := nil;
  ClaimStatsTable.DataSource := ClaimStatsSource;
  ClaimStatsTable.Invalidate;
end;

procedure TGiftAidDetails.SetElementDisplay(const AElementId: string; AVisible: Boolean);
var
  lEl: TJSHTMLElement;
begin
  lEl := TJSHTMLElement(document.getElementById(AElementId));
  if not Assigned(lEl) then
    Exit;
  if AVisible then
    lEl.style.setProperty('display', '')
  else
    lEl.style.setProperty('display', 'none');
end;

function TGiftAidDetails.IsAdjustmentCommentsDump(const AComments: string): Boolean;
var
  lText: string;
begin
  lText := Trim(AComments);
  Result := (lText <> '') and (Copy(lText, Length(lText), 1) = ';') and (Pos(':', lText) > 0);
end;

procedure TGiftAidDetails.ClaimStatsAfterOpen(DataSet: TDataSet);
begin
  SetElementDisplay('ClaimStatsSection', ClaimStats.Active and (not ClaimStats.IsEmpty));
  RefreshClaimStatsTable;
  {$IFDEF PAS2JS}
  asm
    const self = this;
    window.setTimeout(function () {
      self.RefreshClaimStatsTable();
    }, 0);
  end;
  {$ENDIF}
end;

procedure TGiftAidDetails.ClaimStatsAmountGetText(Sender: TField; var Text: string; DisplayText: Boolean);
begin
  Text := FormatFloat(SYS_MONEY_FORMAT, (Sender as TFloatField).AsFloat);
end;

procedure TGiftAidDetails.ClaimStatsCalcFields(Dataset: TDataSet);
var
  lValue: string;
  lType: TGiftAidClaimType;
begin
  lValue := Dataset.FieldByName('ClaimType').AsString;
  { TODO : Should be able to do this with TRttiEnumerationType, but it doesn't work }
  if lValue = 'GAD' then
    lType := TGiftAidClaimType.GAD
  else if lValue = 'GASDS' then
    lType := TGiftAidClaimType.GASDS
  else if lValue = 'Adjustment' then
    lType := TGiftAidClaimType.Adjustment
  else if lValue = 'GASDSAdjustment' then
    lType := TGiftAidClaimType.GASDSAdjustment
  else if lValue = 'AggregatedDonations' then
    lType := TGiftAidClaimType.AggregatedDonations
  else if lValue = 'CommunityBuildings' then
    lType := TGiftAidClaimType.CommunityBuildings
  else if lValue = 'OtherIncome' then
    lType := TGiftAidClaimType.OtherIncome
  else
  begin
    Dataset.FieldByName('Claim_Type').AsString := 'unknown';
    Exit;
  end;

  Dataset.FieldByName('Claim_Type').AsString := C_GA_TYPE_DESCRIPTIONS[lType];
end;

procedure TGiftAidDetails.ClaimStatsGiftAidGetText(Sender: TField; var Text: string; DisplayText: Boolean);
begin
  Text := FormatFloat(SYS_MONEY_FORMAT, (Sender as TFloatField).AsFloat);
end;

procedure TGiftAidDetails.ClaimStatsItemCountGetText(Sender: TField; var Text: string; DisplayText: Boolean);
begin
  Text := FormatFloat('#,##0', (Sender as TIntegerField).AsInteger);
end;

procedure TGiftAidDetails.ClaimStatsTaxYearGetText(Sender: TField; var Text: string; DisplayText: Boolean);
var
  lType: string;
begin
  lType := '';
  if Assigned(Sender.DataSet) then
    lType := Sender.DataSet.FieldByName('ClaimType').AsString;
  { Adjustment stats are one bucket for the claim, not split by year. }
  if (lType = 'Adjustment') or (lType = 'GASDSAdjustment') then
    Text := ''
  else
    Text := Sender.AsString;
end;

procedure TGiftAidDetails.DownloadR68;
var
  lResponse: TXDataClientResponse;
  lResponseObject: JS.TJSObject;
  lOutcome: TResponseOutcome;
  lFileName: string;
begin

  lResponse := await(TXDataClientResponse, MainData.WebClient.RawInvokeAsync('IGiftAiderService.GetR68Report',
    [DataSource.Dataset.FieldByName('Id').AsInteger]));

  lResponseObject := lResponse.ResultAsObject;

  if lResponseObject = nil then
  begin
    ShowMessage('Failed to download report');
    Exit;
  end;

  lOutcome := TRttiEnumerationType.GetValue<TResponseOutcome>(JS.toString(lResponseObject['Outcome']));

  if lOutcome = responseFileNotFound then
  begin
    ShowMessage('Sorry, we can''t find the R68 report. Please contact the GiftAider support team');
    Exit;
  end;

  try
    lFileName := JS.toString(lResponseObject['TheFileName']);
    TFileSupport.SaveEncoded64File(lFileName, JS.toString(lResponseObject['Data']));
  except
    on E: Exception do
    begin
      ShowMessage(E.Message);
    end;
  end;
end;

procedure TGiftAidDetails.GetAmountReceivedFromUser;
var
  AForm: TAmountReceivedForm;
begin
  AForm := TAmountReceivedForm.Create(Self);
  try
    AForm.Popup := True;
    AForm.PopupOpacity := 1;
    AForm.ElementClassName := 'PopUpForm';
    Await(TForm, AForm.Load);

    if not DataSet.Locate('Id', GiftAidId, []) then
    begin
      ShowMessage('The selected record could not be found. Please refresh the list and try again.');
      Exit;
    end;
    AForm.DataSet := DataSet;
    if Await(TModalResult, AForm.Execute) = mrOk then
      Dataset.ApplyUpdates;
  finally
    AForm.Free;
    AForm := nil;
  end;
end;

procedure TGiftAidDetails.R68LinkClick(Sender: TObject);
begin
  DownloadR68;
end;

{ TGiftAidDetails }

procedure TGiftAidDetails.UpdateHMRCErrorDisplay(AClaimStatus: TGiftAidClaimStatus);
var
  lComments: string;
begin
  lComments := Dataset.FieldByName('Comments').AsString;
  if AClaimStatus in [TGiftAidClaimStatus.Error, TGiftAidClaimStatus.SysError, TGiftAidClaimStatus.DataError] then
  begin
    HMRCErrorMessage.Visible := lComments <> '';
    if lComments <> '' then
      HMRCErrorMessage.HTML.Text := '<div class="alert alert-danger mb-2">' + lComments + '</div>';
  end
  else
    HMRCErrorMessage.Visible := False;
end;

procedure TGiftAidDetails.OpenSubmitJob;
var
  lJobId: Integer;
  AForm: TJobDetailBase;
begin
  if Dataset.FieldByName('SubmitJobId').IsNull then
  begin
    ShowMessage('No submit job is linked to this claim.');
    Exit;
  end;

  lJobId := Dataset.FieldByName('SubmitJobId').AsInteger;
  if not SharedData.JobsDataset.Active then
    SharedData.LoadJobs;

  if not SharedData.JobsDataset.Locate('Id', lJobId, []) then
  begin
    ShowMessage('The linked submit job could not be found. It may have been archived.');
    Exit;
  end;

  AForm := FindJobDetailForm(Self, SharedData.JobsDataset.FieldByName('JobType').AsString);
  try
    AForm.Popup := True;
    AForm.PopupOpacity := 1;
    await(TJobDetailBase, AForm.Load());
    AForm.Dataset := SharedData.JobsDataset;
    await(TModalResult, AForm.Execute);
  finally
    AForm.Free;
  end;
end;

procedure TGiftAidDetails.SubmitJobLinkClick(Sender: TObject);
begin
  OpenSubmitJob;
end;

procedure TGiftAidDetails.RecordChanged;
var
  lClaimStatus: TGiftAidClaimStatus;
  lHasSubmitJob: Boolean;
begin
  inherited;
  FOpenedClaimId := DataSource.Dataset.FieldByName('Id').AsInteger;
  FormCaption.Caption := DataSource.Dataset.FieldByName('ClaimRef').AsString;
  lClaimStatus := TRttiEnumerationType.GetValue<TGiftAidClaimStatus>(DataSource.Dataset.FieldByName('ClaimStatus')
    .AsString);
  R68Link.Visible := (lClaimStatus in [TGiftAidClaimStatus.Acknowledged, TGiftAidClaimStatus.Confirmed,
    TGiftAidClaimStatus.PaymentReceived, TGiftAidClaimStatus.ClaimRejected]);

  SetElementDisplay('CommentsRow',
    (lClaimStatus = TGiftAidClaimStatus.Cancelled) and
    (Trim(Dataset.FieldByName('Comments').AsString) <> '') and
    (not IsAdjustmentCommentsDump(Dataset.FieldByName('Comments').AsString)));
  UpdateHMRCErrorDisplay(lClaimStatus);

  lHasSubmitJob := not Dataset.FieldByName('SubmitJobId').IsNull and
    (Dataset.FieldByName('SubmitJobId').AsInteger > 0);
  SubmitJobLink.Visible := lHasSubmitJob and (lClaimStatus in [TGiftAidClaimStatus.Error,
    TGiftAidClaimStatus.SysError, TGiftAidClaimStatus.DataError, TGiftAidClaimStatus.Acknowledged,
    TGiftAidClaimStatus.Submitting]);

  if Dataset.FieldByName('IRMarkReceipt').AsString <> '' then
  begin
    IRMarkReceipt.HTML.Text := Dataset.FieldByName('IRMarkReceipt').AsString;
    IRMarkReceipt.Visible := True;
  end
  else
    IRMarkReceipt.Visible := False;

  SetElementDisplay('ClaimStatsSection', False);
  ClaimStats.QueryString := '$filter=ClaimId eq ' + DataSource.Dataset.FieldByName('Id').AsString;
  ClaimStats.Load;
end;

procedure TGiftAidDetails.ClaimStatsTableGetCellChildren(Sender: TObject; ACol,
    ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
var
  Span: THTMLSpan;
  lKey: string;
  lClaimType: string;

  procedure ViewClick(Sender: TObject);
  var
    lParts: TArray<string>;
    lRecordKey: string;
    lTaxYear: Integer;
  begin
    lRecordKey := TLayoutUtils.GetActionRecordId(Sender);
    lParts := lRecordKey.Split(['|']);
    if Length(lParts) < 2 then
      Exit;
    lTaxYear := StrToIntDef(lParts[1], 0);
    ShowClaimItems(lParts[0], lTaxYear);
  end;

begin
  if ARow = 0 then
    Exit;

  if ACol <> ClaimStatsTable.Columns.Count - 1 then
    Exit;

  lClaimType := ClaimStats.FieldByName('ClaimType').AsString;
  if (lClaimType = 'Adjustment') or (lClaimType = 'GASDSAdjustment') then
    lKey := lClaimType + '|0'
  else
    lKey := lClaimType + '|' + ClaimStats.FieldByName('TaxYear').AsString;

  ClaimStatsTable.Cells[ACol, ARow] := '';
  Span := TLayoutUtils.RowActionSpan(AElement.Element,
    '<button type="button" class="btn btn-primary smx-claim-view-btn">' +
    '<i class="fad fa-eye"></i> View</button>', '');
  Span.ElementClassName := 'smx-claim-view-wrap';
  TLayoutUtils.SetActionRecordId(Span, lKey);
  Span.OnClick := @ViewClick;
end;

function TGiftAidDetails.OpenedClaimStatus: string;
var
  lField: TField;
begin
  Result := '';
  if not Assigned(DataSource) or not Assigned(DataSource.Dataset) then
    Exit;
  lField := DataSource.Dataset.FieldByName('ClaimStatus');
  if lField is TStringField then
    Result := TStringField(lField).Value;
end;

function TGiftAidDetails.OpenedClaimRef: string;
begin
  Result := '';
  if not Assigned(DataSource) or not Assigned(DataSource.Dataset) then
    Exit;
  Result := Trim(DataSource.Dataset.FieldByName('ClaimRef').AsString);
end;

procedure TGiftAidDetails.ShowClaimItems(const AClaimType: string; ATaxYear: Integer);
var
  lClaimId: Integer;
  lTitle: string;
begin
  lClaimId := FOpenedClaimId;
  if lClaimId = 0 then
    lClaimId := DataSource.Dataset.FieldByName('Id').AsInteger;
  if lClaimId = 0 then
    Exit;

  if AClaimType = 'GAD' then
  begin
    ShowClaimDonations(lClaimId, ATaxYear);
    Exit;
  end;

  if (AClaimType = 'Adjustment') or (AClaimType = 'GASDSAdjustment') then
  begin
    if AClaimType = 'GASDSAdjustment' then
      lTitle := 'GASDS Adjustments in this claim'
    else
      lTitle := 'Adjustments in this claim';
    ShowClaimAdjustments(lClaimId, ATaxYear, AClaimType, lTitle);
    Exit;
  end;

  if AClaimType = 'GASDS' then
  begin
    ShowClaimOtherItems(TOtherClaimsGASDSListForm, lClaimId, ATaxYear, '', 'GASDS in this claim');
    Exit;
  end;

  if AClaimType = 'CommunityBuildings' then
  begin
    ShowClaimOtherItems(TOtherClaimsCommunityBuildingsListForm, lClaimId, ATaxYear, '',
      'Community building claims in this claim');
    Exit;
  end;

  if AClaimType = 'ConnectedCharity' then
  begin
    ShowClaimOtherItems(TOtherClaimsConnectedCharitiesListForm, lClaimId, ATaxYear, '',
      'Connected charities in this claim');
    Exit;
  end;

  if AClaimType = 'AggregatedDonations' then
  begin
    ShowClaimOtherItems(TOtherClaimsListForm, lClaimId, ATaxYear, 'AggregatedDonations',
      'Aggregated donations in this claim');
    Exit;
  end;

  if AClaimType = 'OtherIncome' then
  begin
    ShowClaimOtherItems(TOtherClaimsListForm, lClaimId, ATaxYear, 'OtherIncome',
      'Other income in this claim');
    Exit;
  end;
end;

procedure TGiftAidDetails.ShowClaimDonations(AClaimId, ATaxYear: Integer);
var
  lForm: TDonations_List;
begin
  lForm := TDonations_List.Create(Self);
  try
    lForm.Popup := True;
    lForm.PopupOpacity := 1;
    lForm.ElementClassName := 'PopUpForm';
    await(TForm, lForm.Load());
    lForm.TaxYear := ATaxYear;
    lForm.ClaimId := AClaimId;
    lForm.ClaimStatus := OpenedClaimStatus;
    lForm.ClaimRef := OpenedClaimRef;
    lForm.AfterCreated;
    await(TModalResult, lForm.Execute);
  finally
    lForm.Free;
    lForm := nil;
  end;
end;

procedure TGiftAidDetails.ShowClaimAdjustments(AClaimId, ATaxYear: Integer;
    const AEntitySetName, ATitle: string);
var
  lForm: TClaimAdjustmentsPopup;
begin
  lForm := TClaimAdjustmentsPopup.Create(Self);
  try
    lForm.Popup := True;
    lForm.PopupOpacity := 1;
    lForm.ElementClassName := 'PopUpForm';
    lForm.ClaimId := AClaimId;
    lForm.TaxYear := ATaxYear;
    lForm.ClaimStatus := OpenedClaimStatus;
    lForm.PopupTitle := ATitle;
    lForm.ClaimRef := OpenedClaimRef;
    await(TForm, lForm.Load());
    if Assigned(lForm.ClaimAdjData) and (AEntitySetName <> '') and
       not SameText(lForm.ClaimAdjData.EntitySetName, AEntitySetName) then
    begin
      lForm.ClaimAdjData.Close;
      lForm.ClaimAdjData.EntitySetName := AEntitySetName;
    end;
    lForm.AfterCreated;
    await(TModalResult, lForm.Execute);
  finally
    lForm.Free;
    lForm := nil;
  end;
end;

procedure TGiftAidDetails.ShowClaimOtherItems(AFormClass: TFormClass; AClaimId,
    ATaxYear: Integer; const AEntitySetName, ATitle: string);
var
  AForm: TClaimScopedListForm;
begin
  AForm := TClaimScopedListForm(AFormClass.Create(Self));
  try
    AForm.Popup := True;
    AForm.PopupOpacity := 1;
    AForm.ElementClassName := 'PopUpForm';
    AForm.SetClaimContext(AClaimId, ATaxYear, OpenedClaimStatus);
    await(TForm, AForm.Load());

    if AForm is TOtherClaimsListForm then
    begin
      TOtherClaimsListForm(AForm).OtherClaimsTitle := ATitle;
      if AEntitySetName <> '' then
        TOtherClaimsListForm(AForm).OtherClaimsType := AEntitySetName;
    end;

    AForm.ApplyClaimContextUI;
    await(TModalResult, AForm.Execute);
  finally
    AForm.Free;
    AForm := nil;
  end;
end;

procedure TGiftAidDetails.LoadDFMValues;
begin
  inherited LoadDFMValues;

  GiftAidId := TDBLabel.Create('GiftAidId');
  TransactionId := TDBLabel.Create('TransactionId');
  CorrelationId := TDBLabel.Create('CorrelationId');
  ClaimRef := TDBLabel.Create('ClaimRef');
  ClaimStatus := TDBLabel.Create('ClaimStatus');
  Comments := TDBLabel.Create('Comments');
  HMRCErrorMessage := THTMLSpan.Create('HMRCErrorMessage');
  SubmitJobLink := TLabel.Create('SubmitJobLink');
  SubmissionDate := TDBLabel.Create('SubmissionDate');
  IRMark := TDBLabel.Create('IRMark');
  R68Link := TLabel.Create('R68Link');
  AmountReceived := TDBLabel.Create('AmountReceived');
  AmountReceivedCurrency := TLabel.Create('AmountReceivedCurrency');
  ClaimStatsTable := TDBTableControl.Create('ClaimStatsTable');
  IRMarkReceipt := THTMLSpan.Create('IRMarkReceipt');
  AmountReceivedButton := TButton.Create('AmountReceivedButton');
  ClaimStats := TXDataWebDataSet.Create(Self);
  ClaimStatsId := TIntegerField.Create(Self);
  ClaimStatsClaimId := TIntegerField.Create(Self);
  ClaimStatsGiftAid := TFloatField.Create(Self);
  ClaimStatsAmount := TFloatField.Create(Self);
  ClaimStatsClaimType := TStringField.Create(Self);
  ClaimStatsItemCount := TIntegerField.Create(Self);
  ClaimStatsClaim_Type := TStringField.Create(Self);
  ClaimStatsTaxYear := TIntegerField.Create(Self);
  ClaimStatsSource := TDataSource.Create(Self);

  GiftAidId.BeforeLoadDFMValues;
  TransactionId.BeforeLoadDFMValues;
  CorrelationId.BeforeLoadDFMValues;
  ClaimRef.BeforeLoadDFMValues;
  ClaimStatus.BeforeLoadDFMValues;
  Comments.BeforeLoadDFMValues;
  HMRCErrorMessage.BeforeLoadDFMValues;
  SubmitJobLink.BeforeLoadDFMValues;
  SubmissionDate.BeforeLoadDFMValues;
  IRMark.BeforeLoadDFMValues;
  R68Link.BeforeLoadDFMValues;
  AmountReceived.BeforeLoadDFMValues;
  AmountReceivedCurrency.BeforeLoadDFMValues;
  ClaimStatsTable.BeforeLoadDFMValues;
  IRMarkReceipt.BeforeLoadDFMValues;
  AmountReceivedButton.BeforeLoadDFMValues;
  ClaimStats.BeforeLoadDFMValues;
  ClaimStatsId.BeforeLoadDFMValues;
  ClaimStatsClaimId.BeforeLoadDFMValues;
  ClaimStatsGiftAid.BeforeLoadDFMValues;
  ClaimStatsAmount.BeforeLoadDFMValues;
  ClaimStatsClaimType.BeforeLoadDFMValues;
  ClaimStatsItemCount.BeforeLoadDFMValues;
  ClaimStatsClaim_Type.BeforeLoadDFMValues;
  ClaimStatsTaxYear.BeforeLoadDFMValues;
  ClaimStatsSource.BeforeLoadDFMValues;
  try
    GiftAidId.SetParentComponent(Self);
    GiftAidId.Name := 'GiftAidId';
    GiftAidId.Left := 48;
    GiftAidId.Top := 104;
    GiftAidId.Width := 47;
    GiftAidId.Height := 15;
    GiftAidId.Caption := 'GiftAidId';
    GiftAidId.ElementFont := efCSS;
    GiftAidId.HeightStyle := ssAuto;
    GiftAidId.HeightPercent := 100.000000000000000000;
    GiftAidId.WidthPercent := 100.000000000000000000;
    GiftAidId.DataField := 'Id';
    GiftAidId.DataSource := DataSource;
    TransactionId.SetParentComponent(Self);
    TransactionId.Name := 'TransactionId';
    TransactionId.Left := 48;
    TransactionId.Top := 136;
    TransactionId.Width := 71;
    TransactionId.Height := 15;
    TransactionId.Caption := 'TransactionId';
    TransactionId.ElementFont := efCSS;
    TransactionId.HeightStyle := ssAuto;
    TransactionId.HeightPercent := 100.000000000000000000;
    TransactionId.WidthPercent := 100.000000000000000000;
    TransactionId.DataField := 'TransactionId';
    TransactionId.DataSource := DataSource;
    CorrelationId.SetParentComponent(Self);
    CorrelationId.Name := 'CorrelationId';
    CorrelationId.Left := 48;
    CorrelationId.Top := 143;
    CorrelationId.Width := 76;
    CorrelationId.Height := 15;
    CorrelationId.Caption := 'Correlation Id';
    CorrelationId.ElementFont := efCSS;
    CorrelationId.HeightStyle := ssAuto;
    CorrelationId.HeightPercent := 100.000000000000000000;
    CorrelationId.WidthPercent := 100.000000000000000000;
    CorrelationId.ElementPosition := epIgnore;
    CorrelationId.DataField := 'CorrelationId';
    CorrelationId.DataSource := DataSource;
    ClaimRef.SetParentComponent(Self);
    ClaimRef.Name := 'ClaimRef';
    ClaimRef.Left := 48;
    ClaimRef.Top := 165;
    ClaimRef.Width := 48;
    ClaimRef.Height := 15;
    ClaimRef.Caption := 'ClaimRef';
    ClaimRef.ElementFont := efCSS;
    ClaimRef.HeightStyle := ssAuto;
    ClaimRef.HeightPercent := 100.000000000000000000;
    ClaimRef.WidthPercent := 100.000000000000000000;
    ClaimRef.DataField := 'ClaimRef';
    ClaimRef.DataSource := DataSource;
    ClaimStatus.SetParentComponent(Self);
    ClaimStatus.Name := 'ClaimStatus';
    ClaimStatus.Left := 48;
    ClaimStatus.Top := 180;
    ClaimStatus.Width := 63;
    ClaimStatus.Height := 15;
    ClaimStatus.Caption := 'ClaimStatus';
    ClaimStatus.ElementFont := efCSS;
    ClaimStatus.HeightStyle := ssAuto;
    ClaimStatus.HeightPercent := 100.000000000000000000;
    ClaimStatus.WidthPercent := 100.000000000000000000;
    ClaimStatus.DataField := 'ClaimStatus';
    ClaimStatus.DataSource := DataSource;
    Comments.SetParentComponent(Self);
    Comments.Name := 'Comments';
    Comments.Left := 48;
    Comments.Top := 172;
    Comments.Width := 55;
    Comments.Height := 15;
    Comments.Caption := 'Comments';
    Comments.ElementFont := efCSS;
    Comments.HeightStyle := ssAuto;
    Comments.HeightPercent := 100.000000000000000000;
    Comments.WidthPercent := 100.000000000000000000;
    Comments.DataField := 'Comments';
    Comments.DataSource := DataSource;
    HMRCErrorMessage.SetParentComponent(Self);
    HMRCErrorMessage.Name := 'HMRCErrorMessage';
    HMRCErrorMessage.Left := 48;
    HMRCErrorMessage.Top := 210;
    HMRCErrorMessage.Width := 480;
    HMRCErrorMessage.Height := 40;
    HMRCErrorMessage.HeightStyle := ssAuto;
    HMRCErrorMessage.WidthStyle := ssAuto;
    HMRCErrorMessage.ChildOrder := 5;
    HMRCErrorMessage.ElementPosition := epIgnore;
    HMRCErrorMessage.Visible := False;
    HMRCErrorMessage.Role := '';
    SubmitJobLink.SetParentComponent(Self);
    SubmitJobLink.Name := 'SubmitJobLink';
    SubmitJobLink.Left := 48;
    SubmitJobLink.Top := 255;
    SubmitJobLink.Width := 120;
    SubmitJobLink.Height := 15;
    SubmitJobLink.Cursor := crHandPoint;
    SubmitJobLink.Caption := 'View submit job';
    SubmitJobLink.ElementFont := efCSS;
    SubmitJobLink.HeightStyle := ssAuto;
    SubmitJobLink.HeightPercent := 100.000000000000000000;
    SubmitJobLink.Visible := False;
    SubmitJobLink.WidthPercent := 100.000000000000000000;
    SubmitJobLink.ElementPosition := epIgnore;
    SetEvent(SubmitJobLink, Self, 'OnClick', 'SubmitJobLinkClick');
    SubmissionDate.SetParentComponent(Self);
    SubmissionDate.Name := 'SubmissionDate';
    SubmissionDate.Left := 48;
    SubmissionDate.Top := 195;
    SubmissionDate.Width := 85;
    SubmissionDate.Height := 15;
    SubmissionDate.Caption := 'SubmissionDate';
    SubmissionDate.ElementFont := efCSS;
    SubmissionDate.HeightStyle := ssAuto;
    SubmissionDate.HeightPercent := 100.000000000000000000;
    SubmissionDate.WidthPercent := 100.000000000000000000;
    SubmissionDate.DataField := 'SubmissionDate';
    SubmissionDate.DataSource := DataSource;
    IRMark.SetParentComponent(Self);
    IRMark.Name := 'IRMark';
    IRMark.Left := 48;
    IRMark.Top := 195;
    IRMark.Width := 37;
    IRMark.Height := 15;
    IRMark.Caption := 'IRMark';
    IRMark.ElementFont := efCSS;
    IRMark.HeightStyle := ssAuto;
    IRMark.HeightPercent := 100.000000000000000000;
    IRMark.WidthPercent := 100.000000000000000000;
    IRMark.DataField := 'IRMark';
    IRMark.DataSource := DataSource;
    R68Link.SetParentComponent(Self);
    R68Link.Name := 'R68Link';
    R68Link.Left := 48;
    R68Link.Top := 240;
    R68Link.Width := 57;
    R68Link.Height := 15;
    R68Link.Cursor := crHandPoint;
    R68Link.Caption := 'R68 Report';
    R68Link.ElementFont := efCSS;
    R68Link.HeightStyle := ssAuto;
    R68Link.HeightPercent := 100.000000000000000000;
    R68Link.Visible := False;
    R68Link.WidthPercent := 100.000000000000000000;
    SetEvent(R68Link, Self, 'OnClick', 'R68LinkClick');
    AmountReceived.SetParentComponent(Self);
    AmountReceived.Name := 'AmountReceived';
    AmountReceived.Left := 74;
    AmountReceived.Top := 304;
    AmountReceived.Width := 91;
    AmountReceived.Height := 15;
    AmountReceived.Caption := 'AmountReceived';
    AmountReceived.ElementFont := efCSS;
    AmountReceived.HeightStyle := ssAuto;
    AmountReceived.HeightPercent := 100.000000000000000000;
    AmountReceived.WidthPercent := 100.000000000000000000;
    AmountReceived.DataField := 'AmountReceived';
    AmountReceived.DataSource := DataSource;
    AmountReceivedCurrency.SetParentComponent(Self);
    AmountReceivedCurrency.Name := 'AmountReceivedCurrency';
    AmountReceivedCurrency.Left := 62;
    AmountReceivedCurrency.Top := 304;
    AmountReceivedCurrency.Width := 6;
    AmountReceivedCurrency.Height := 15;
    AmountReceivedCurrency.Caption := #163;
    AmountReceivedCurrency.HeightPercent := 100.000000000000000000;
    AmountReceivedCurrency.WidthPercent := 100.000000000000000000;
    ClaimStatsTable.SetParentComponent(Self);
    ClaimStatsTable.Name := 'ClaimStatsTable';
    ClaimStatsTable.Left := 560;
    ClaimStatsTable.Top := 136;
    ClaimStatsTable.Width := 300;
    ClaimStatsTable.Height := 200;
    ClaimStatsTable.HeightStyle := ssAuto;
    ClaimStatsTable.WidthStyle := ssAuto;
    ClaimStatsTable.BorderColor := clSilver;
    ClaimStatsTable.ChildOrder := 18;
    ClaimStatsTable.ElementPosition := epIgnore;
    ClaimStatsTable.Columns.Clear;
    with ClaimStatsTable.Columns.Add do
    begin
      DataField := 'Claim_Type';
      Title := 'Claim Type';
    end;
    with ClaimStatsTable.Columns.Add do
    begin
      ElementClassName := 'text-end';
      DataField := 'Amount';
      Title := 'Amount';
      TitleElementClassName := 'text-end';
    end;
    with ClaimStatsTable.Columns.Add do
    begin
      ElementClassName := 'text-end';
      DataField := 'GiftAid';
      Title := 'Gift Aid';
      TitleElementClassName := 'text-end';
    end;
    with ClaimStatsTable.Columns.Add do
    begin
      ElementClassName := 'text-end';
      DataField := 'TaxYear';
      Title := 'Tax Year';
      TitleElementClassName := 'text-end';
    end;
    with ClaimStatsTable.Columns.Add do
    begin
      ElementClassName := 'text-end';
      DataField := 'ItemCount';
      Title := 'Count';
      TitleElementClassName := 'text-end';
    end;
    with ClaimStatsTable.Columns.Add do
    begin
      Title := '';
    end;
    ClaimStatsTable.DataSource := ClaimStatsSource;
    SetEvent(ClaimStatsTable, Self, 'OnGetCellChildren', 'ClaimStatsTableGetCellChildren');
    IRMarkReceipt.SetParentComponent(Self);
    IRMarkReceipt.Name := 'IRMarkReceipt';
    IRMarkReceipt.Left := 252;
    IRMarkReceipt.Top := 240;
    IRMarkReceipt.Width := 100;
    IRMarkReceipt.Height := 40;
    IRMarkReceipt.WidthStyle := ssAuto;
    IRMarkReceipt.ChildOrder := 18;
    IRMarkReceipt.ElementPosition := epIgnore;
    IRMarkReceipt.Role := '';
    AmountReceivedButton.SetParentComponent(Self);
    AmountReceivedButton.Name := 'AmountReceivedButton';
    AmountReceivedButton.Left := 424;
    AmountReceivedButton.Top := 450;
    AmountReceivedButton.Width := 96;
    AmountReceivedButton.Height := 25;
    AmountReceivedButton.Caption := 'Change Amount Received';
    AmountReceivedButton.ChildOrder := 19;
    AmountReceivedButton.ElementClassName := 'btn btn-secondary';
    AmountReceivedButton.HeightPercent := 100.000000000000000000;
    AmountReceivedButton.WidthPercent := 100.000000000000000000;
    SetEvent(AmountReceivedButton, Self, 'OnClick', 'AmountReceivedButtonClick');
    ClaimStats.SetParentComponent(Self);
    ClaimStats.Name := 'ClaimStats';
    ClaimStats.AfterOpen := ClaimStatsAfterOpen;
    SetEvent(ClaimStats, Self, 'OnCalcFields', 'ClaimStatsCalcFields');
    ClaimStats.EntitySetName := 'GiftAidClaimStats';
    ClaimStats.Connection := MainData.DataConnection;
    ClaimStats.Left := 520;
    ClaimStats.Top := 24;
    ClaimStatsId.SetParentComponent(ClaimStats);
    ClaimStatsId.Name := 'ClaimStatsId';
    ClaimStatsId.FieldName := 'Id';
    ClaimStatsId.Required := True;
    ClaimStatsClaimId.SetParentComponent(ClaimStats);
    ClaimStatsClaimId.Name := 'ClaimStatsClaimId';
    ClaimStatsClaimId.FieldName := 'ClaimId';
    ClaimStatsClaimId.Required := True;
    ClaimStatsGiftAid.SetParentComponent(ClaimStats);
    ClaimStatsGiftAid.Name := 'ClaimStatsGiftAid';
    ClaimStatsGiftAid.FieldName := 'GiftAid';
    ClaimStatsGiftAid.Required := True;
    SetEvent(ClaimStatsGiftAid, Self, 'OnGetText', 'ClaimStatsGiftAidGetText');
    ClaimStatsAmount.SetParentComponent(ClaimStats);
    ClaimStatsAmount.Name := 'ClaimStatsAmount';
    ClaimStatsAmount.FieldName := 'Amount';
    ClaimStatsAmount.Required := True;
    SetEvent(ClaimStatsAmount, Self, 'OnGetText', 'ClaimStatsAmountGetText');
    ClaimStatsClaimType.SetParentComponent(ClaimStats);
    ClaimStatsClaimType.Name := 'ClaimStatsClaimType';
    ClaimStatsClaimType.FieldName := 'ClaimType';
    ClaimStatsClaimType.Required := True;
    ClaimStatsClaimType.Size := 19;
    ClaimStatsItemCount.SetParentComponent(ClaimStats);
    ClaimStatsItemCount.Name := 'ClaimStatsItemCount';
    ClaimStatsItemCount.FieldName := 'ItemCount';
    ClaimStatsItemCount.Required := True;
    SetEvent(ClaimStatsItemCount, Self, 'OnGetText', 'ClaimStatsItemCountGetText');
    ClaimStatsClaim_Type.SetParentComponent(ClaimStats);
    ClaimStatsClaim_Type.Name := 'ClaimStatsClaim_Type';
    ClaimStatsClaim_Type.FieldKind := fkCalculated;
    ClaimStatsClaim_Type.FieldName := 'Claim_Type';
    ClaimStatsClaim_Type.Size := 30;
    ClaimStatsClaim_Type.Calculated := True;
    ClaimStatsTaxYear.SetParentComponent(ClaimStats);
    ClaimStatsTaxYear.Name := 'ClaimStatsTaxYear';
    ClaimStatsTaxYear.FieldName := 'TaxYear';
    ClaimStatsTaxYear.Required := True;
    SetEvent(ClaimStatsTaxYear, Self, 'OnGetText', 'ClaimStatsTaxYearGetText');
    ClaimStatsSource.SetParentComponent(Self);
    ClaimStatsSource.Name := 'ClaimStatsSource';
    ClaimStatsSource.DataSet := ClaimStats;
    ClaimStatsSource.Left := 608;
    ClaimStatsSource.Top := 24;
  finally
    GiftAidId.AfterLoadDFMValues;
    TransactionId.AfterLoadDFMValues;
    CorrelationId.AfterLoadDFMValues;
    ClaimRef.AfterLoadDFMValues;
    ClaimStatus.AfterLoadDFMValues;
    Comments.AfterLoadDFMValues;
    HMRCErrorMessage.AfterLoadDFMValues;
    SubmitJobLink.AfterLoadDFMValues;
    SubmissionDate.AfterLoadDFMValues;
    IRMark.AfterLoadDFMValues;
    R68Link.AfterLoadDFMValues;
    AmountReceived.AfterLoadDFMValues;
    AmountReceivedCurrency.AfterLoadDFMValues;
    ClaimStatsTable.AfterLoadDFMValues;
    IRMarkReceipt.AfterLoadDFMValues;
    AmountReceivedButton.AfterLoadDFMValues;
    ClaimStats.AfterLoadDFMValues;
    ClaimStatsId.AfterLoadDFMValues;
    ClaimStatsClaimId.AfterLoadDFMValues;
    ClaimStatsGiftAid.AfterLoadDFMValues;
    ClaimStatsAmount.AfterLoadDFMValues;
    ClaimStatsClaimType.AfterLoadDFMValues;
    ClaimStatsItemCount.AfterLoadDFMValues;
    ClaimStatsClaim_Type.AfterLoadDFMValues;
    ClaimStatsTaxYear.AfterLoadDFMValues;
    ClaimStatsSource.AfterLoadDFMValues;
  end;
end;

end.
